module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};



/*****************
 ** WEBPACK FOOTER
 ** (webpack)-dev-server/~/socket.io-client/~/socket.io-parser/~/isarray/index.js
 ** module id = 11
 ** module chunks = 0
 **/